import Lender from "./Lender.jsx";
export default Lender;
